var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestAgain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3362_73851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.168 3.83398V8.83398H14.168",
    stroke: "#0076A1",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0756 13.0003C16.5339 14.5336 15.5085 15.8493 14.154 16.7491C12.7995 17.6489 11.1893 18.0841 9.5659 17.9892C7.94254 17.8942 6.39401 17.2742 5.15368 16.2226C3.91335 15.1709 3.0484 13.7447 2.68919 12.1587C2.32997 10.5727 2.49595 8.91299 3.1621 7.42956C3.82826 5.94613 4.9585 4.71939 6.38251 3.9342C7.80652 3.14902 9.44716 2.84792 11.0572 3.07629C12.6672 3.30466 14.1594 4.05012 15.3089 5.20034L19.1672 8.83367",
    stroke: "#0076A1",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3362_73851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestAgain);
export default __webpack_public_path__ + "static/media/test-again.d87f2bb3363d7bf4bfd7296bf38ea2c0.svg";
export { ForwardRef as ReactComponent };